import { Invitation, LetterInvitation } from '../components/Invitations';
import { InvitationalLetterDetails } from '../components/LetterInvite';
import { serverUrl } from '../config';

export type InvitationsResponse = {
  standard: Invitation[];
  letter: LetterInvitation[];
};

export const fetchInvitations = (token: string) => (): Promise<InvitationsResponse> => {
  const fetchUrl = `${serverUrl}/api/invitations/`;
  const request = {
    method: 'get',
    headers: { authorization: `Token ${token}` },
  };

  return fetch(fetchUrl, request).then((res) => res.json());
};

export const fetchInvitationalLetterDetails =
  (invitationId: string) => (): Promise<InvitationalLetterDetails> => {
    const url = `${serverUrl}/api/letter-invite/${invitationId}`;
    console.log(url);
    return fetch(url, { method: 'get' }).then((res) => res.json());
  };
